<app-list-animations-reunions *ngIf="loadingData; else loader" [allList]="listAllReunions" [permToAdd]="permToAdd"
  [listEnfant]="listChild" [contrats]="listContrats" [configMentalo]="configMentalo" type="reunion"
  (unsubscribeEvent)="unsubscribe($event)" (unsubscribeChildEvent)="unsubscribeChild($event)"
  (registerChildEvent)="registerChild($event)">
</app-list-animations-reunions>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>